import React, { lazy } from "react"
const ContactPage = lazy(() => import("./ContactPage"))

export const ContactRoutes = [{ path: "", element: <ContactPage /> }]
